export const DEFAULT_GOAL_QUESTION = "How well has [name] met their goals in the past month?"
export const DEFAULT_CULTURE_QUESTION = "How well did [name] contribute to our company values this past month?"

export const DEFAULT_GOAL_LABELS: Record<number, string> = {
  4: "Exceeded",
  3: "Met",
  2: "Partially",
  1: "Did not Meet"
}

export const DEFAULT_CULTURE_LABELS: Record<number, string> = {
  4: "Significantly",
  3: "Consistently",
  2: "Somewhat",
  1: "Rarely"
}

export const DEFAULT_GOAL_TEXT_PREFIXES: Record<number, string> = {
  4: "Exceeded Goals",
  3: "Met Goals",
  2: "Partially Goals",
  1: "Did not Meet Goals"
}

export const DEFAULT_CULTURE_TEXT_PREFIXES: Record<number, string> = {
  4: "Significantly Contributes to Values",
  3: "Consistently Contributes to Values",
  2: "Somewhat Contributes to Values",
  1: "Rarely Contributes to Values"
}

export const RECOMMENDED_MAX_CUSTOM_QUESTIONS = 3
